import React from 'react'

const Footer=()=>(
  <footer>
    <div className="footer-1">
    <div className="logo-container">
      <img src="logo-luis.svg" alt="logo-luis" className="logo-image"/>
    </div>
    <div className="social-media">
      <ul className="social-list">
        <li className="social-item">
          <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100008221219436"><img className='social-icon' src="media/icons/facebook.svg" alt="link-facebook"/></a>
        </li>
        <li className="social-item">
          <a target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=51993471271"><img className='social-icon' src="media/icons/whatsapp.svg" alt="link-whatsapp"/></a>
        </li>
        <li className="social-item">
          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/luisfelipadelgado/"><img className='social-icon' src="media/icons/instagram.svg" alt="link-instagram"/></a>
        </li>
        <li className="social-item">
          <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/luis-felipa/"><img className='social-icon' src="media/icons/linkedin.svg" alt="link-linkedin"/></a>
        </li>
      </ul>
    </div>
    </div>
    <div className="rights">
      <p className="rights-text">Luis Dev's, All rights reserved &copy; 2020 | Desarrollado por Luis Felipa</p>
    </div>
  </footer>
)

export default Footer
